import React from 'react';

const AdminPage: React.FC = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>관리팀 페이지</h1>
      <p>로그인 후 접근 가능한 관리자 페이지입니다.</p>
      <p>추후 구현 예정입니다.</p>
    </div>
  );
};

export default AdminPage;